import React, { useEffect, useState, useMemo } from "react";
import { Container, Row, Col, Form, Button, Card, Spinner } from "react-bootstrap";
import "../../Styles/yellowcalfcss/PayBill.css";
import { useLocation, useNavigate } from "react-router-dom";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { toast, ToastContainer } from "react-toastify";

/* ---------- helpers ---------- */
const parseAmount = (val) => {
  if (val === null || val === undefined) return 0;
  if (typeof val === "number") return val;
  return Number(String(val).replace(/[^0-9.]/g, "")) || 0;
};

export function PayBill() {
  const location = useLocation();
  const navigate = useNavigate();

  const selectedBillIds = location.state?.billIds || [];

  /* ---------------- STATE ---------------- */
  const [bills, setBills] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paymentDate, setPaymentDate] = useState("");
  const [bankId, setBankId] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [amount, setAmount] = useState("");
  const [banks, setBanks] = useState([]);


  /* ---------------- FETCH BILLS ---------------- */
  useEffect(() => {
    if (selectedBillIds.length === 0) return;
    fetchBills();
  }, [selectedBillIds]);

  const fetchBills = async () => {
    setLoading(true);

    const requestBody = {
      customer_id: Number(localStorage.getItem("customer_id")),
      api_key: localStorage.getItem("api_key"),
      user_id: Number(localStorage.getItem("user_id")),
      language: "en",
      id: selectedBillIds,
    };

    try {
      const response = await simplePostCall(
        ApiConfig.billIndex,
        JSON.stringify(requestBody)
      );
console.log('response-1--', response)
      if (response?.result) {
        console.log('response-2--', response)
        setBills(response.bills || []);
        setBanks(response.bank || []);
      } else {
        toast.error(response?.message || "Failed to load bills");
      }
    } catch (err) {
      toast.error("Network error");
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- CALCULATIONS ---------------- */
  const totalAmount = useMemo(
    () => bills.reduce((sum, b) => sum + parseAmount(b.bill_total_amount), 0),
    [bills]
  );

  const paidAmount = useMemo(
    () => bills.reduce((sum, b) => sum + parseAmount(b.bill_paid_amount), 0),
    [bills]
  );

  const pendingAmount = useMemo(
    () =>
      bills.reduce((sum, b) => sum + parseAmount(b.bill_pending_amount), 0),
    [bills]
  );

  /* ---------------- PAY BILL ---------------- */
  const handleCreate = async () => {
    if (!bankId || !amount) {
      toast.error("Bank and amount are required");
      return;
    }

    setLoading(true);

    const requestBody = {
      customer_id: Number(localStorage.getItem("customer_id")),
      api_key: localStorage.getItem("api_key"),
      user_id: Number(localStorage.getItem("user_id")),
      language: "en",
      id: selectedBillIds,
      bank_id: Number(bankId),
      amount: Number(amount),
     action:'true',
     payment_mode : paymentMode

    };

    try {
      const response = await simplePostCall(
        ApiConfig.billIndex,
        JSON.stringify(requestBody)
      );

      if (response?.result) {
        toast.success(response.message || "Payment successful");
    
        navigate("/accountant/bill");
      } else {
        toast.error(response?.message || "Payment failed");
      }
    } catch (err) {
      toast.error("Network error");
    } finally {
      setLoading(false);
    }
  };

  function formatDate(dateString) {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}

  /* ---------------- UI ---------------- */
  return (
    <div className="paybill-main-wrapper">
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="paybill-content-container">
        {/* TITLE */}
        <Card className="paybill-title-card mb-3" style={{backgroundColor:'#fff'}}>
          <Card.Body>
            <h3 className="paybill-main-heading">Pay Bill</h3>
          </Card.Body>
        </Card>

        {/* FORM */}
        <Card className="paybill-form mb-3" style={{backgroundColor:'#fff'}}>
          <Card.Body>
            <Row>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Payment Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={paymentDate}
                    onChange={(e) => setPaymentDate(e.target.value)}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>
                    Bank <span className="text-danger">*</span>
                  </Form.Label>
                 <Form.Select
  value={bankId}
  onChange={(e) => setBankId(e.target.value)}
>
  <option value="">Select</option>

  {banks.map((bank) => (
    <option key={bank.bank_id} value={bank.bank_id}>
      {bank.bank_name} ({bank.bank_account_number})
    </option>
  ))}
</Form.Select>
                </Form.Group>
              </Col>

           <Col md={6} className="mt-2">
  <Form.Group>
    <Form.Label>
      Mode Of Payment <span className="text-danger">*</span>
    </Form.Label>

    <Form.Select
      value={paymentMode}
      onChange={(e) => setPaymentMode(e.target.value)}
    >
      <option value="">Select</option>
      <option value="by cash">By Cash</option>
      <option value="cheque">Cheque</option>
      <option value="dd">DD</option>
      <option value="bank transfer">Bank Transfer</option>
      <option value="mpesa_manual">Mpesa</option>
      <option value="wallet">Wallet</option>
    </Form.Select>
  </Form.Group>
</Col>
            </Row>
          </Card.Body>
        </Card>
{console.log('taleeb_bills.length--',bills)}
<Card className="paybill-table-header-card mb-2">
  <Card.Body>
    <Row className="text-center fw-bold">
      <Col md={1}>#</Col>
      <Col md={2}>Bill Number</Col>
      <Col md={2}>Supplier</Col>
      <Col md={2}>Bill Date</Col>
      <Col md={2}>Due Date</Col>
      <Col md={1}>Paid Amount</Col>
      <Col md={2}> Total Amount</Col>
    </Row>
  </Card.Body>
</Card>
        {/* TABLE */}
        <Card className="mb-3" style={{backgroundColor:'#fff'}}>
          <Card.Body>
            {loading ? (
              <div className="text-center p-4">
                <Spinner animation="border" />
              </div>
            ) : bills.length === 0 ? (
              <div className="text-center">No bills found</div>
            ) : (
              bills.map((bill, index) => (
                <Row key={bill.bill_id} className="mb-2 text-center">
                  <Col md={1}>{index + 1}</Col>
                  <Col md={2}>{bill.bill_number}</Col>
                  <Col md={2}>{bill.supplier_name}</Col>
                  <Col md={2}>{formatDate(bill.bill_date)}</Col>
                  <Col md={2}>{formatDate(bill.bill_due_date)}</Col>
                  <Col md={2}>{parseAmount(bill.bill_paid_amount)}</Col>
                  <Col md={1}>{parseAmount(bill.bill_total_amount)}</Col>
                </Row>
              ))
            )}
          </Card.Body>
        </Card>

        {/* SUMMARY */}
        <Card className="mb-3" style={{backgroundColor:'#fff'}}>
          <Card.Body>
            <Row>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Total Amount Payable *</Form.Label>
                  <Form.Control
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <strong>Pending:</strong> {pendingAmount}
              </Col>
              <Col md={4}>
                <strong>Paid:</strong> {paidAmount}
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* ACTION */}
        <div className="text-end">
          <Button onClick={handleCreate} disabled={loading}>
            {loading ? <Spinner size="sm" /> : "Create"}
          </Button>
        </div>
      </div>
    </div>
  );
}
